import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {  EmpDetailsReportAndDashboard } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../digital-identity-api-endpoints";

interface GetIdentityViewsResponse {
  digitalidentityreports: EmpDetailsReportAndDashboard[];
}

@Injectable({
  providedIn: "root",
})
export class DigitalIdentityReportService {
  private readonly digitalidentityreportsUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}
  
  getDiReports(selectedFilter: string): Observable<EmpDetailsReportAndDashboard[]> {
    return this.http
      .post<GetIdentityViewsResponse>(
        `${this.digitalidentityreportsUrl}${API_ENDPOINTS.REPORTS.FETCH}`,
        { selectedFilter }
      )
      .pipe(
        map((response) => response.digitalidentityreports),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getDiChartData(selectedFilter:string): Observable<EmpDetailsReportAndDashboard[]> {
    return this.http
      .post<GetIdentityViewsResponse>(
        `${this.digitalidentityreportsUrl}${API_ENDPOINTS.DASHBOARD.FETCHCHARTDATA}`,
        { selectedFilter}
      )
      .pipe(
        map((response) => response.digitalidentityreports),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

}
